import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'hr', name: 'HR', flag: '🇭🇷' },
    { code: 'en', name: 'ENG', flag: '🇬🇧' },
    { code: 'de', name: 'DE', flag: '🇩🇪' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="fixed top-6 right-6 z-50 flex gap-2 bg-gray-800/90 backdrop-blur border border-gray-700 rounded-lg p-2 shadow-xl">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-300 ${
            i18n.language === lang.code
              ? 'bg-red-600 text-white shadow-lg scale-105'
              : 'bg-transparent text-gray-300 hover:bg-gray-700 hover:text-white'
          }`}
        >
          <span className="text-xl">{lang.flag}</span>
          <span className="font-semibold text-sm">{lang.name}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
